"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var main_store_service_1 = require("@nw/ui-core-shared/store/main-store.service");
var DealerblockHighestBidComponent = (function () {
    function DealerblockHighestBidComponent(mainStoreService) {
        this.mainStoreService = mainStoreService;
        this.lang = '';
    }
    DealerblockHighestBidComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.mainStoreService.getStore().select(function (state) { return state.appPrincipal; })
            .subscribe(function (principal) {
            _this.lang = principal.language ? principal.language : 'en';
        });
    };
    return DealerblockHighestBidComponent;
}());
DealerblockHighestBidComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'nw-dealerblock-highest-bid',
                template: "<span  class=\"label\">{{ 'dealerBlockLayout.highestBid' | translate }}</span>\n<span  class=\"info\" data-a8n=\"db-highest-bid\">{{(winningBidAmount ? winningBidAmount : startPrice) | nwCurrency : lang }}</span>\n\n",
                styles: [""]
            },] },
];
/** @nocollapse */
DealerblockHighestBidComponent.ctorParameters = function () { return [
    { type: main_store_service_1.MainStoreService, },
]; };
DealerblockHighestBidComponent.propDecorators = {
    'winningBidAmount': [{ type: core_1.Input },],
    'startPrice': [{ type: core_1.Input },],
    'bidderCount': [{ type: core_1.Input },],
    'nwVehicleId': [{ type: core_1.Input },],
};
exports.DealerblockHighestBidComponent = DealerblockHighestBidComponent;
//# sourceMappingURL=dealerblock-highest-bid.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/components/dealerblock-highest-bid/dealerblock-highest-bid.component.js
// module id = pujC
// module chunks = 0